<template>
	<div class="white-box">
		<h3 class="box-title">TAREAS POR ESTADOS</h3>
		<doughnut-chart :options="options" :chart-data="datacollection"></doughnut-chart>
	</div>
</template>
<script>
	import DoughnutChart from './../../../../charts/basics/DoughnutChart.vue';
	export default {
		props: ['user', 'isAuth'],
		components: {
			DoughnutChart,
		},
		data () {
			return {
				data: null,
				labels: [],
				series: [],
				backgroundColor: [],

				datacollection: null,

				chart: null,

				options: {
					responsive: true,
					legend: {
						display: true,
					},
				},
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
				this.getData()
			},
			getData() {
				this.$http.get('admin/projects/charts/status/tasks')
				.then(response => {
					this.data = response.body
					this.loadData()
					//this.setTimeOut()
				})
			},
			loadData() {
				var that = this

				var labels = []
				var series = []
				var backgroundColor = []

				$.each(this.data, function(index, value) {
					labels.push(value.label)
					series.push(value.data)
					backgroundColor.push(value.backgroundColor)
				})

				this.labels = labels
				this.series = series
				this.backgroundColor = backgroundColor

				this.datacollection = {
					labels: this.labels,
					datasets: [
						{
							data: this.series,
							backgroundColor: this.backgroundColor,
						}
					],
				}
			},
			setTimeOut() {
				var that = this
				setTimeout(function(){
					var time = moment().format('mm:ss')
					that.getData()
				}, 5000);
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/dashboard/views/charts/statusTasks.vue